import React from "react";
import BoxItemCard from "./parts/BoxItemCard";
import BoxItemHeader from "./parts/BoxItemHeader";
import BoxItemImage from "./parts/BoxItemImage";
import BoxItemSkuInfo from "./parts/BoxItemSkuInfo";
import { ICancelledItemUI } from "../../../lib/interfaces/ConveyorBox/IConveyorBox";
import { BoxItemAssignedShelfNumber } from "./parts/BoxItemAssignedShelf";
import { Progress } from "semantic-ui-react";
import BoxItemRibbon from "./parts/BoxItemRibbon";

type Props = {
  item: ICancelledItemUI;
  isSelected: boolean;
};

const CancelledBoxItem = ({ item, isSelected }: Props) => {
  const {
    article,
    attributes,
    sku,
    varunummer,
    isRestocked,
    operatorAssignedShelf,
    cancelledQuantityVerified,
    cancelledQuantity,
  } = item;
  return (
    <BoxItemCard isSelected={isSelected}>
      {/* <BoxItemOverlays isCancelled /> */}
      <CancelledItemRibbon isRestocked={isRestocked} isSelected={isSelected} />
      <BoxItemHeader title={article.name} attributes={attributes} />
      <BoxItemImage imageUrl={article.imageUrl} />
      <BoxItemSkuInfo skuId={sku.id} weight={article.weight} varunummer={varunummer} />
      {isRestocked ? (
        <BoxItemAssignedShelfNumber
          shelf={operatorAssignedShelf}
          quantity={cancelledQuantityVerified}
        />
      ) : (
        <Progress
          size="large"
          value={cancelledQuantityVerified}
          total={cancelledQuantity}
          progress="ratio"
          color={"blue"}
          active={cancelledQuantityVerified < cancelledQuantity}
        ></Progress>
      )}
    </BoxItemCard>
  );
};

export const CancelledItemRibbon = ({
  isRestocked,
  isSelected,
}: {
  isRestocked: boolean;
  isSelected: boolean;
}) => {
  if (isRestocked) return <BoxItemRibbon text="Inskannad" type="success" />;
  else if (isSelected) return <BoxItemRibbon text="Hanteras" type="default" />;
  else return <BoxItemRibbon text="Avbruten" type="danger" />;
};

export default CancelledBoxItem;
